package com.example.monetix.ui.theme

import androidx.compose.ui.graphics.Color

// 🎨 COLORI MODALITÀ CHIARA (Stile FinTech Minimal)
val LightBackground = Color(0xFFFFFFFF)       // Bianco puro
val LightSurface = Color(0xFFF2F2F7)          // Grigio chiarissimo per le Card
val LightPrimary = Color(0xFF000000)          // Nero assoluto (es. per i pulsanti principali)
val LightOnPrimary = Color(0xFFFFFFFF)        // Testo bianco sui pulsanti neri
val LightText = Color(0xFF1C1C1E)             // Testo principale
val LightTextMuted = Color(0xFF8E8E93)        // Testo secondario (Note, date)

// 🌙 COLORI MODALITÀ SCURA (Stile FinTech Dark)
val DarkBackground = Color(0xFF000000)        // Nero puro
val DarkSurface = Color(0xFF1C1C1E)           // Grigio scuro per le Card (stile Apple/Revolut)
val DarkPrimary = Color(0xFFFFFFFF)           // Bianco assoluto (pulsanti principali in dark mode)
val DarkOnPrimary = Color(0xFF000000)         // Testo nero sui pulsanti bianchi
val DarkText = Color(0xFFF2F2F7)              // Testo principale chiaro
val DarkTextMuted = Color(0xFF8E8E93)         // Testo secondario

// Colori Semantici (Uguali per entrambi o leggermente adattati)
val ColorIncome = Color(0xFF34C759)           // Verde acceso
val ColorExpense = Color(0xFFFF3B30)          // Rosso acceso
val ColorTransfer = Color(0xFF007AFF)         // Blu elettrico